export default __webpack_public_path__ + "static/media/icon_train.b2cb6ffb.png";